import React from 'react'
import { Flex } from 'theme-ui'
import { useResponsiveValue } from '@theme-ui/match-media'

import { SectionContainerStyled, SectionContentStyled, SectionMediaStyled, SectionMobileCtaStyled, SectionMarkStyled } from './styles'
import Section from './../Section/index'
import Heading from './../../molecules/Heading'
import Button from './../../atoms/Button'
import StaticImage from './../../atoms/ImageStatic'
import MediaItem from './../../molecules/MediaItem'

import { AdvancedTradingProps } from './types'

const AdvancedTradingToolsSection: React.FC<AdvancedTradingProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,

  data
}) => {
  const isDesktop = useResponsiveValue([false, false, true, true], {
    defaultIndex: 0
  })

  const { media, mark, content } = data

  return (
    <Section
      {...{ id, inner, paddingTop, paddingBottom, headingPadding, bgColor, heading, isHeadingGreen, subheading, description, data }}
      body={
        <>
          <SectionContainerStyled>
            {media && (
              <SectionMediaStyled>
                {media.image || media.video ? <MediaItem {...{ media }} /> : ''}
                {mark && (
                  <SectionMarkStyled>
                    <StaticImage image={mark} />
                  </SectionMarkStyled>
                )}
              </SectionMediaStyled>
            )}
            <SectionContentStyled>
              <Flex>
                <Heading title={content.title} subtitle={content.subtitle} />
              </Flex>
              {isDesktop && content.button && (
                <Flex>
                  <Button variant="withArrow" {...content.button} />
                </Flex>
              )}
            </SectionContentStyled>
            {!isDesktop && content.button && (
              <SectionMobileCtaStyled>
                <Button variant="withArrow" {...content.button} />
              </SectionMobileCtaStyled>
            )}
          </SectionContainerStyled>
        </>
      }
    />
  )
}

export default AdvancedTradingToolsSection
